module.exports = __webpack_public_path__ + "static/img/products application_cooler3.8ee2a685.jpg";